<template>
  <div class="login-container">
    <b-card>
      <div class="logo-wrapper">
        <img :src="logo"
             alt="">
      </div>
      <h5 style="color: #ffffff" class="mb-5">Continue with Email</h5>
      <!--      <div class="title-wrapper">
              <h4>Login</h4>
            </div>-->
      <b-form>
        <div class="input-wrapper mb-2">
          <label for="email">Email</label>
          <input v-model="formData.email"
                 id="email"
                 placeholder="Enter your email" />
          <div class="error-msg"></div>
        </div>
        <div class="input-wrapper mb-2">
          <label for="password">Password</label>
          <input type="password"
                 id="password"
                 v-model="formData.password"
                 placeholder="Enter your password" />
          <div class="error-msg"></div>
        </div>
        <div class="text-center">
          <b-btn class="btn-yellow" @click.prevent="submit">Login</b-btn>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import appLogo from '@/assets/img/logo.svg'

export default {
  name: "Login",
  props: ['modelValue'],
  emits: ['update:modelValue'],
  data () {
    return {
      logo: appLogo,
      formData: {
        email: '',
        password: '',
      }
    }
  },
  methods: {
    submit () {
      this.$store.dispatch('auth/login', this.formData).then(() => {
        console.log('** logged in successfully **')
        this.$store.dispatch('auth/getOwnProfile').then(() => {
          this.$router.push('/account')
        })
        .catch(() => {
          this.$store.dispatch('auth/logout')
        })
        // this.$emit('closeModal')
      })
      .catch(e => {
        console.log('err => ', e)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;

  .logo-wrapper {
    margin-bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 65px;
      width: 65px;
    }
  }
  .card {
    background-color: transparent;
    border-color: transparent;
  }

  .input-wrapper {
    position: relative;
    label {
      position: absolute;
      font-size: 13px;
      font-weight: lighter;
      top: -5px;
      left: 10px;
      color: #fff;
    }
    input {
      padding: 8px 10px;
      font-weight: lighter;
      color: #ffffff;
      margin-bottom: 20px;
      background-color: transparent!important;
      border-color: transparent!important;
      border-bottom: 1px solid #ffffff!important;
      outline: none;

      &::placeholder {
        font-weight: lighter;
        font-size: 11px;
        color: lightblue;
      }
    }
  }

  .btn-yellow {
    background: #F1BC04;
    border-color: #F1BC04;
    border-radius: 45px;
    color: #000000;
  }
}
</style>
